import React from 'react';
import LegalPage, { CONTACT_EMAIL, CONTACT_PHONE } from '../components/LegalPage';

export default function Terms() {
  return (
    <LegalPage
      title="Terms of Service"
      intro="These Terms govern your use of the One13 app. By creating an account or using One13, you agree to these Terms. If you do not agree, do not use the app."
      otherHref="/privacy"
      otherLabel="Privacy Policy"
    >
      <h2>1. The service</h2>
      <p>
        One13 is a bookkeeping and inventory-management app that lets you record your business
        transactions and view reports and financial statements. We provide the app on an ongoing
        basis and may add, change, or remove features.
      </p>

      <h2>2. Your account</h2>
      <ul>
        <li>You must provide accurate information and keep your login details secure.</li>
        <li>
          You are responsible for all activity under your account and any staff accounts you create.
        </li>
        <li>You must be at least 18 and authorised to act for your business.</li>
      </ul>

      <h2>3. Your data and your responsibilities</h2>
      <ul>
        <li>
          You own your business records. You are responsible for the accuracy of what you enter.
        </li>
        <li>
          You are responsible for having the right to record any third party’s information (e.g. your
          customers) and for complying with laws that apply to you.
        </li>
        <li>You must not use One13 for any unlawful purpose or to store unlawful content.</li>
      </ul>

      <h2>4. Fees</h2>
      <p>
        <strong>One13 is currently free.</strong> We are in a pilot period and are not collecting
        payment at this time.
      </p>
      <p>
        Our intended price is ₦2,000 per month. We will tell you the price clearly and give you
        reasonable notice before any charging begins, and we may change pricing on reasonable notice.
        You will never be charged without being told first.
      </p>

      <h2>5. Important limitations — please read</h2>
      <div className="legal-callout">
        <p>
          <strong>One13 is a tool, not an accountant or tax adviser.</strong> One13 helps you keep
          records and generates reports based on what you enter. It does not provide accounting, tax,
          legal, or financial advice, and its reports are only as accurate as the data you record.
          You are responsible for your own tax and regulatory obligations. For formal accounts, tax
          filings, or important decisions, consult a qualified professional.
        </p>
      </div>
      <p>You use the reports and figures One13 produces at your own discretion and risk.</p>

      <h2>6. Availability</h2>
      <p>
        We aim to keep One13 available and reliable but do not guarantee uninterrupted service. The
        app is provided “as is” and “as available”. We may suspend the service for maintenance or for
        reasons beyond our control.
      </p>

      <h2>7. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, One13 and its operator are not liable for indirect or
        consequential losses, lost profits, or loss of data, arising from your use of the app. Nothing
        in these Terms excludes liability that cannot be excluded by law.
      </p>

      <h2>8. Suspension and termination</h2>
      <ul>
        <li>You may stop using One13 and close your account at any time.</li>
        <li>We may suspend or terminate access if you breach these Terms or use the app unlawfully.</li>
        <li>
          On termination, you may request an export or deletion of your data, subject to our Privacy
          Policy.
        </li>
      </ul>

      <h2>9. Intellectual property</h2>
      <p>
        One13, its name, and its software belong to us. These Terms do not give you any ownership of
        the app itself — only the right to use it while you comply with these Terms. Your business
        data remains yours.
      </p>

      <h2>10. Governing law</h2>
      <p>
        These Terms are governed by the laws of the Federal Republic of Nigeria, and disputes are
        subject to the jurisdiction of the Nigerian courts.
      </p>

      <h2>11. Contact</h2>
      <p>
        Questions about these Terms or the Privacy Policy:{' '}
        <a href={'mailto:' + CONTACT_EMAIL}>{CONTACT_EMAIL}</a> · {CONTACT_PHONE}
      </p>
    </LegalPage>
  );
}
